import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, xs },
} = constants.breakpoints;
const { colors } = constants;
const { textSObj } = typographyStyles;
const blue = colors.brand.blue[25];
const darkBlue = colors.ui.core[700];

export const panelBodyCss = {
  padding: "24px 24px 0px",

  [mediaQuery.upTo(md)]: {
    padding: "32px 40px 0px",
  },

  [mediaQuery.upTo(xs)]: {
    padding: "24px 16px",
  },
};

export const messageContainerCss = {
  ...textSObj,
  display: "flex",
  backgroundColor: colors.brand.blue[25],
  color: darkBlue,
  padding: "16px",
  width: "100%",
  borderRadius: "8px",
};

export const anchorCss = {
  color: darkBlue,

  "div > div": {
    verticalAlign: "sub",
  },
};

export const textCss = {
  margin: "0 0 8px 0",
  lineHeight: "24px",
};

export const iconCss = {
  margin: "2px 8px 0 0",
  width: "100%",
  maxWidth: "18px",
  height: "100%",
  maxHeight: "18px",

  circle: {
    fill: darkBlue,
    stroke: darkBlue,
  },

  path: {
    stroke: blue,
  },
};
